<template>
    <header>
        <div v-if="isPartnerApp"
            class="partner-login-header"
        >
            <img :src="require(`@webapp/assets/socios-logo-vertical.webp`)"
                alt="Socios Logo"
                class="logo-socios"
            >
            <div class="separator" />
            <img v-if="partnerLogo"
                :src="partnerLogo"
                alt="Partner Logo"
                class="logo-partner"
            >
        </div>
        <div v-else
            class="logo"
        >
            <img :src="require(`@webapp/assets/socios-logo-horizontal.webp`)"
                alt="Socios Logo"
                class="logo__image"
            >
        </div>
    </header>
</template>

<script>
// Store
import {
    mapGetters,
} from 'vuex';

// Components
export default {
    name: 'login-header',
    computed: {
        ...mapGetters([
            'isPartnerApp',
            'partnerAppData',
        ]),

        ...mapGetters('partners', ['partnerById']),

        partnerLogo() {
            if (this.partnerAppData) {
                return this.partnerById(this.partnerAppData.id).partnerLogo;
            }

            return false;
        },
    },
};
</script>

<style lang="scss" scoped>
header {
    padding: 3.5rem 2.5rem 4rem;
    display: flex;

    @include min-width(lg) {
        padding-bottom: 5rem;
    }
}

.logo {
    text-align: center;
    flex: 1;
    margin: 1rem 0 2rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    @include min-width(lg) {
        text-align: left;
        margin: 0;
        flex-direction: row;
    }

    &__image {
        height: 40px;
    }

    &__tagline {
        color: $blue-charcoal-color;
        font-size: 1.2rem;

        @include min-width(lg) {
            margin-left: 3rem;
        }
    }
}

.partner-login-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .logo-socios,
    .logo-partner {
        height: 60px;
        width: auto;
    }

    .separator {
        width: 2px;
        height: 100%;
        background-color: $white-color;
        margin: 0 20px;
    }
}
</style>